/**
 * @see https://cemexpmo.atlassian.net/browse/CX030GO2103-15492
 **/
export const DEFAULT_COUNTRY_CODE = 'XX';

/**
 * Dummy email to avoid in remnder
 * If the api email not return any email, the email will be validated whit the dummyEmailList
 * If the email is in the list of emails, it will be removed
*/
export const DUMMY_EMAILS = ['pending@nodata.com', 'ccm.rp-default@cemexlabs.com'];

